export async function downloadElement(element: HTMLElement, fileName: string) {
	const { domToCanvas } = await import("modern-screenshot")
	const canvas = await domToCanvas(element, {
		backgroundColor: "#ffffff",
		filter: node => !(node instanceof HTMLCanvasElement && node.getAttribute("aria-hidden") === "true"),
		scale: window.devicePixelRatio,
	})

	const data = canvas.toDataURL("image/png")
	const link = document.createElement("a")

	if (typeof link.download === "string") {
		link.href = data
		link.download = fileName
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	} else {
		window.open(data)
	}
}

export function downloadBlob(blob: Blob, fileName: string) {
	const url = URL.createObjectURL(blob)
	const link = document.createElement("a")
	link.href = url
	link.download = fileName
	document.body.appendChild(link)
	link.click()
	link.remove()
	// Revoking synchronously can cancel the download in some browsers before it has read the blob
	setTimeout(() => URL.revokeObjectURL(url), 1000)
}
